import {
  MdOutlineCalculate,
  MdOutlineHelpOutline,
  MdOutlineInfo,
  MdOutlinePayments,
} from 'react-icons/md';

import { FontSize, FontWeight } from 'commons';
import { Heading, Text, Tooltip } from 'components';
import { integerToCurrency } from 'helpers';
import { HappyPersonIcon } from 'static/icons';
import { Balance } from 'types';

import * as S from './styles';

interface Props {
  balance?: Balance;
  isValidating: boolean;
}

export function GeneralValueCards({ balance, isValidating }: Props) {
  if (isValidating) {
    return (
      <S.Wrapper>
        <S.SkeletonCard />
        <S.SkeletonCard />
        <S.SkeletonCard />
      </S.Wrapper>
    );
  }

  if (!balance) return <></>;

  const { available, waitingFunds } = balance;

  const currentBalance = integerToCurrency(available?.value || 0, {
    removeCurrencySymbol: true,
  });

  const futureBalance = integerToCurrency(waitingFunds?.value || 0, {
    removeCurrencySymbol: true,
  });

  return (
    <S.Wrapper>
      <S.Card $isFigureCard>
        <S.DescriptionWrapper>
          <Text>Confira os valores de</Text>
          <Text size={FontSize.font18} weight={FontWeight.bold}>
            saldo e a receber
          </Text>
        </S.DescriptionWrapper>

        <S.FigureWrapper>
          <HappyPersonIcon />
        </S.FigureWrapper>
      </S.Card>
      <S.Card>
        <S.IconWrapper>
          <MdOutlinePayments />
        </S.IconWrapper>

        <S.DescriptionWrapper>
          <S.Description>
            <Text>Saldo atual</Text>

            <Tooltip
              message={'Valor a receber na próxima data de transferência'}
            >
              <div className="icon">
                <MdOutlineInfo />
              </div>
            </Tooltip>
          </S.Description>

          <S.ValueWrapper $positive>
            <Text size={FontSize.font16} weight={FontWeight.bold}>
              R$
            </Text>

            <Heading size={FontSize.font24} weight={FontWeight.bold}>
              {currentBalance}
            </Heading>
          </S.ValueWrapper>
        </S.DescriptionWrapper>
      </S.Card>
      <S.Card>
        <S.IconWrapper>
          <MdOutlineCalculate />
        </S.IconWrapper>

        <S.DescriptionWrapper>
          <S.Description>
            <Text>Valor a receber</Text>

            <Tooltip message={'Valores futuros a serem recebidos'}>
              <div className="icon">
                <MdOutlineHelpOutline />
              </div>
            </Tooltip>
          </S.Description>

          <S.ValueWrapper>
            <Text size={FontSize.font16} weight={FontWeight.bold}>
              R$
            </Text>

            <Heading size={FontSize.font24} weight={FontWeight.bold}>
              {futureBalance}
            </Heading>
          </S.ValueWrapper>
        </S.DescriptionWrapper>
      </S.Card>
    </S.Wrapper>
  );
}
